// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca907376","885":"9b8a4d29"}[chunkId] + ".chunk.js";
};